module.exports = __webpack_public_path__ + "static/media/bg_reportssaved_inaction.653a44e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/bg_reportssaved_inaction.svg
// module id = 490
// module chunks = 51